import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["colors", "disabled", "deleted", "select", "className", "bordered", "children", "clsPrefix", "closeIcon", "icon", "visible", "onClock", "tagClick"];

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../../wui-icon/src';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  /**
   * @title 样式
   */
  style: PropTypes.object,

  /**
   * @title 形状
   */
  bordered: PropTypes.bool,

  /**
   * @title 类型
   */
  colors: PropTypes.string,

  /**
   * @title 是否禁用
   * @veIgnore
   */
  disabled: PropTypes.bool,

  /**
  * @title 是否删除
  * @veIgnore
  */
  deleted: PropTypes.bool,

  /**
   * @title 是否选中
   * @veIgnore
   */
  select: PropTypes.bool,

  /**
   * @title 标签是否显示关闭图标
   * @veIgnore
   */
  visible: PropTypes.bool,

  /**
   * @title 类名
   * @veIgnore
   */
  className: PropTypes.string,

  /**
   * @title 标签点击事件 已兼容onClick
   * @veIgnore
   */
  tagClick: PropTypes.func,

  /**
  * @title 标签关闭回调函数
  * @veIgnore
  */
  onClose: PropTypes.func,

  /**
  * @title 标签关闭自定义按钮
  * @veIgnore
  */
  closeIcon: PropTypes.node,

  /**
  * @title 设置图标
  * @veIgnore
  */
  icon: PropTypes.element
};
var defaultProps = {
  disabled: false,
  deleted: false,
  colors: 'light',
  visible: true,
  bordered: false,
  select: false,
  style: {},
  className: '',
  closeIcon: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-close"
  }),
  icon: null
};
var colorsMap = {
  dark: 'dark',
  light: 'light',
  primary: 'primary',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  info: 'info'
};
var Tag = (_dec = WebUI({
  name: "tag",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Tag, _Component);

  var _super = _createSuper(Tag);

  function Tag(props) {
    var _this;

    _classCallCheck(this, Tag);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "click", function (e) {
      _this.setState({
        selected: !_this.state.selected
      });

      _this.props.tagClick && _this.props.tagClick(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onDelete", function (e) {
      _this.setState({
        visible: !_this.state.visible
      });

      _this.props.onClose && _this.props.onClose(e);
    });

    _this.state = {
      selected: false,
      visible: props.visible
    };
    return _this;
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colors = _this$props.colors,
          disabled = _this$props.disabled,
          deleted = _this$props.deleted,
          select = _this$props.select,
          className = _this$props.className,
          bordered = _this$props.bordered,
          children = _this$props.children,
          clsPrefix = _this$props.clsPrefix,
          closeIcon = _this$props.closeIcon,
          icon = _this$props.icon,
          visible = _this$props.visible,
          onClock = _this$props.onClock,
          tagClick = _this$props.tagClick,
          others = _objectWithoutProperties(_this$props, _excluded);

      var clsObj = {};

      if (className) {
        clsObj[className] = true;
      }

      if (colorsMap[colors]) {
        clsObj["".concat(clsPrefix, "-").concat(colorsMap[colors])] = true;
      }

      if (bordered) {
        clsObj["".concat(clsPrefix, "-border")] = bordered;
      }

      if (select) {
        clsObj["".concat(clsPrefix, "-select")] = select;
      }

      if (deleted) {
        clsObj["".concat(clsPrefix, "-delete")] = deleted;
      }

      if (icon) {
        clsObj["".concat(clsPrefix, "-icon")] = icon;
      } // "选择标签"选中时，改变标签的样式，单独写了一个selected类


      if (this.props.select == true) {
        if (this.state.selected) {
          clsObj["".concat(clsPrefix, "-selected")] = true;
        }
      }

      var classes = classnames(clsPrefix, clsObj);
      var style = colors && !colorsMap[colors] ? _objectSpread(_objectSpread({}, others.style), {}, {
        color: '#fff',
        border: "1px solid ".concat(colors),
        backgroundColor: colors
      }) : _objectSpread({}, others.style);
      return this.state.visible ? /*#__PURE__*/React.createElement("span", _extends({}, others, {
        style: style,
        className: classes,
        disabled: disabled,
        onClick: this.click
      }), icon && /*#__PURE__*/React.createElement("span", {
        className: "icon"
      }, icon), children, deleted && /*#__PURE__*/React.createElement("span", {
        onClick: this.onDelete
      }, closeIcon)) : null;
    }
  }]);

  return Tag;
}(Component)) || _class);
Tag.propTypes = propTypes;
export default Tag;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tag/src/Tag.js